<template>
  <div>
    <PedidosListFilters
      :metodo-payment-filter.sync="metodoPaymentFilter"
      :status-filter.sync="statusFilter"
      :integracao-filter.sync="integracaoFilter"
      :data-inicio-filter.sync="dataInicioFilter"
      :data-fim-filter.sync="dataFimFilter"
      :metodo-payment-options="metodoPaymentOptions"
      :status-options="statusOptions"
      :integracao-options="integracaoOptions"
    />
    <b-card no-body>
      <b-overlay
        :show="showLoadingGenrandoNfe"
        rounded="md"
      >
        <div class="m-2">

          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="3"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <!-- <label>Entradas</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block ml-50 mr-1"
              /> -->
            </b-col>
            <!-- Search -->
            <b-col
              cols="12"
              md="9"
            >
              <b-row class="justify-content-end">
                <b-col
                  cols="12"
                  md="6"
                >
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="ID, Nome Cliente, Documento"
                  />
                </b-col>
                <!-- <b-col
                  cols="12"
                  md="auto"
                >
                  <export-excel
                    :data="$store.getters['appClientPedidos/GET_PEDIDOS']"
                    :fields="$store.getters['appClientPedidos/GET_FIELDS_PEDIDO']"
                    :name="`pedidos-${statusFilter}-${new Date().getTime()}`"
                  >
                    <b-button
                      variant="primary"
                    >
                      Exportar
                      <feather-icon
                        icon="DownloadIcon"
                        size="18"
                        class="ml-50"
                      />
                    </b-button>
                  </export-excel>
                </b-col> -->
              </b-row>
            </b-col>

            <b-col
              v-if="$can('manage', 'all')"
              cols="12"
              class="mt-2"
            >
              <!-- <b-row>
                <b-col
                  cols="12"
                  md="6"
                >
                  <b-button
                    size="sm"
                    class="mr-1"
                    variant="primary"
                    @click="selectAllRows"
                  >
                    Select all
                  </b-button>
                  <b-button
                    size="sm"
                    class="mr-1"
                    variant="primary"
                    @click="clearSelected"
                  >
                    Clear selected
                  </b-button>
                  <span
                    v-if="selected.length > 0"
                    class="mr-1"
                  >
                    <strong class="font-weight-bold">
                      {{ selected.length }}
                    </strong>
                    {{ selected.length === 1 ? 'pedido' : 'pedidos' }} selecionado
                  </span>
                </b-col>
                <b-col
                  v-if="selected.length > 0"
                  cols="12"
                  md="6"
                  class="d-flex justify-content-end"
                  style="gap: 10px;"
                >
<!--                  <div>-->
<!--                    <b-button-->
<!--                      size="sm"-->
<!--                      variant="outline-info"-->
<!--                      @click="downloadMessPdfsNfe(selected)"-->
<!--                    >-->
<!--                      Download PDFs NF-e-->
<!--                    </b-button>-->
<!--                  </div>-->
                  <!-- <div>
                    <b-button
                      size="sm"
                      variant="outline-success"
                      @click="gerarNfeInMass(selected)"
                    >
                      Gerar NF-e em Massa
                    </b-button>
                  </div>
                  <div>
                    <b-button
                      size="sm"
                      variant="outline-info"
                      @click="gerarNfeInMass(selected)"
                    >
                      Re-Enviar E-mail NF-e
                    </b-button>
                  </div>
                </b-col> -->
              <!-- </b-row> -->

            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refPedidosListTable"
          :items="findAll"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Nenhum registro encontrado"
          :sort-desc.sync="isSortDirDesc"
          select-mode="multi"
          selectable
          class="position-relative"
          @row-selected="onRowSelected"
        >
          <template #head(info_order)>
            <feather-icon
              icon="TrendingUpIcon"
              class="mx-auto"
            />
          </template>

          <!-- Column: Id -->
          <template #cell(id)="data">
            <b-link
              :to="{ name: 'app-client-pedido-preview', params: { id: data.item.id } }"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <!-- Column: Invoice Status -->
          <template #cell(info_order)="data">
            <b-avatar
              :id="`invoice-row-${data.item.id}`"
              size="32"
              :variant="`light-${
                resolverOrderStatusIconAndVariant(data.item.status).variant
              }`"
            >
              <feather-icon
                :icon="resolverOrderStatusIconAndVariant(data.item.status).icon"
              />
            </b-avatar>
            <b-tooltip
              :target="`invoice-row-${data.item.id}`"
              placement="top"
            >
              <p class="mb-0">
                {{ resolveStatusText(data.item.status) }}
              </p>
              <p class="mb-0">
                Valor Total: {{ data.item.pedido_itens.comissoes | currencyInt }}
              </p>
              <p class="mb-0">
                Data Venda: {{ data.item.data_venda | formatDateTimeBr }}
              </p>
            </b-tooltip>
          </template>

          <!-- Column: Client -->
          <template #cell(client)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.avatar"
                  :text="avatarText(data.item.cliente.nome)"
                  :variant="`light-primary`"
                />
              </template>
              <span class="font-weight-bold d-block text-nowrap">
                {{ data.item.cliente.nome }}
              </span>
              <small class="text-muted">{{ data.item.cliente.usuarios[0].login }}</small>
            </b-media>
          </template>

          <!-- Column: Issued Date -->
          <template #cell(issuedDate)="data">
            <span class="text-nowrap">
              {{ data.value }}
            </span>
          </template>

          <!-- Column: Status do Pedido -->
          <template #cell(status)="data">
            <template>
              <b-badge
                pill
                :variant="`light-${resolverStatusVariante(data.value)}`"
              >
                {{ resolveStatusText(data.value) }}
              </b-badge>
            </template>
          </template>

          <!-- Column: Metodo de pagamento -->
          <template #cell(condicao_pagamento)="data">
            <template>
              <div>
                {{ resolveCondicaoPagamento(data.value.id) }}
              </div>
            </template>
          </template>

          <!-- Column: Data Criação -->
          <template #cell(data_inclusao)="data">
            <span class="text-nowrap">
              {{ data.value | formatDateTimeBr }}
            </span>
          </template>

          <!-- Column: Valor total -->
          <template #cell(valor_total_pedido)="data">
            <span class="text-nowrap">
              {{ calcularTotalComissoes(data.item.pedido_itens) | currency }}
            </span>
          </template>

          <!-- Column: Data Criação -->
          <template #cell(data_venda)="data">
            <span class="text-nowrap">
              {{ data.value | formatDateBr }}
            </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">


              <!-- <b-tooltip
                title="Reenviar E-mail do PIX"
                class="cursor-pointer"
                :target="`invoice-row-${data.item.id}-resend-mail-pixel-icon`"
              />
              <b-button
                v-if="data.item.condicao_pagamento.condicao_pagamento === 'PIX' && data.item.status.toLowerCase() === 'waiting_payment'"
                :id="`invoice-row-${data.item.id}-resend-mail-pixel-icon`"
                class="btn-icon p-0"
                size="sm"
                variant="flat"
                @click="reenviarEmailPix(data.item.id)"
              >
                <iconfy
                  color="blue"
                  height="24"
                  icon="ic:baseline-pix"
                />
              </b-button>
              <b-tooltip
                title="Reenviar E-mail PIX"
                class="cursor-pointer"
                :target="`invoice-row-${data.item.id}-resend-mail-pixel-icon`"
              /> -->
              <!-- <feather-icon
                v-if="data.item.bling_link_pdf === null && data.item.status.toLowerCase() === 'paid'"
                :id="`invoice-row-${data.item.id}-send-icon`"
                icon="SendIcon"
                class="cursor-pointer"
                color="blue"
                size="20"
                @click="gerarNfe(data.item.id)"
              />
              <b-tooltip
                title="Gerar Nota Fiscal"
                class="cursor-pointer"
                :target="`invoice-row-${data.item.id}-send-icon`"
              /> -->

              <!-- <feather-icon
                v-if="data.item.bling_link_pdf !== null"
                :id="`invoice-row-${data.item.id}-download-pdf-icon`"
                icon="DownloadIcon"
                class="cursor-pointer ml-1"
                size="20"
                color="green"
                @click="downloadPdfLink(data.item)"
              />
              <b-tooltip
                title="Download PDF"
                class="cursor-pointer"
                :target="`invoice-row-${data.item.id}-download-pdf-icon`"
              /> -->

              <feather-icon
                :id="`invoice-row-${data.item.id}-preview-icon`"
                icon="EyeIcon"
                size="20"
                class="mx-1"
                color="info"
                @click="
                  $router.push({
                    name: 'app-client-pedido-preview',
                    params: { id: data.item.id },
                  })
                "
              />
              <b-tooltip
                title="Visualizar Pedido"
                :target="`invoice-row-${data.item.id}-preview-icon`"
              />
            </div>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!-- <span
                class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} entries</span> -->
            </b-col>
            <!-- Pagination -->
            <!-- <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalInvoices"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col> -->
          </b-row>
        </div>
        <template #overlay>
          <div class="text-center">
            <b-spinner
              md
              class="mb-2"
            />
            <h5 class="text-bold font-weight-bold">
              {{ nameLoading }}
            </h5>
          </div>
        </template>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  avatarText,
  currency,
  currencyInt,
  currencyIntCents,
  formatDateBr,
  formatDateTimeBr,
} from '@core/utils/filter'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  BOverlay,
  BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import { socket } from '@/socket.ts'
import { ref } from '@vue/composition-api'
import axios from 'axios'
import SweetAlert from 'sweetalert2'
import usePedidoList from './usePedidoList'
import 'sweetalert2/src/sweetalert2.scss'
import { resendMailPix, sendMassNfeBling, sendNfeBling } from '@/services/pedidos.serve'
import PedidosListFilters from './PedidosListFilters.vue'

export default {
  components: {
    PedidosListFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BTooltip,
    BOverlay,
    vSelect,
    BSpinner,
  },
  filters: {
    formatDateTimeBr,
    currency,
    formatDateBr,
    currencyInt,
    currencyIntCents,
  },
  methods: {
    selectAllRows() {
      this.$refs.refPedidosListTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.refPedidosListTable.clearSelected()
    },
  },
  setup() {
    const selected = ref([])
    const nameLoading = ref('Gerando Nota Fiscal Eletrônica...')
    const onRowSelected = items => {
      selected.value = items
        .filter(p => p.bling_chave_acesso !== null)
    }

    const calcularTotalComissoes = pedidoItens => {
      if (!pedidoItens || !Array.isArray(pedidoItens)) return 0
      // Percorre todos os itens do pedido
      return pedidoItens.reduce((totalPedido, item) => {
        // Verifica se item.comissoes existe e é um array
        if (!item.comissoes || !Array.isArray(item.comissoes)) return totalPedido
        // Soma todas as comissões.resto deste item
        const totalComissoesItem = item.comissoes.reduce((totalItem, comissao) => {
          // Verifica se a comissão tem a propriedade resto
          const valorResto = comissao && comissao.resto ? Number(comissao.resto) : 0
          return totalItem + valorResto
        }, 0)
        return totalPedido + totalComissoesItem
      }, 0)
    }

    const {
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPedidosListTable,
      statusOptions,

      statusFilter,
      metodoPaymentFilter,
      metodoPaymentOptions,
      integracaoFilter,
      integracaoOptions,
      dataInicioFilter,
      dataFimFilter,

      refetchData,

      resolverOrderStatusIconAndVariant,
      resolverStatusVariante,
      resolveStatusText,
      resolveCondicaoPagamento,
      resolveCondicaoPagamentoVariant,
      resolveAprovado,
      resolveAprovadoVariant,
    } = usePedidoList()

    const showLoadingGenrandoNfe = ref(false)

    const downloadPdfLink = pedido => new Promise(resolve => {
      const link = document.createElement('a')
      link.href = pedido.bling_link_pdf
      link.download = `NovoNome_${pedido.id}.pdf`

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      resolve()
    })

    // eslint-disable-next-line no-shadow
    const reenviarEmailPix = async idPedido => {
      await resendMailPix(idPedido)
        .then(response => {
          SweetAlert.fire({
            icon: 'success',
            title: 'Sucesso',
            text: response.message,
            confirmButtonText: 'Ok',
          })
        })
        .catch(() => {
          SweetAlert.fire({
            icon: 'error',
            title: 'Tente novamente mais tarde',
            text: 'Não foi possível reenviar o e-mail do PIX',
            confirmButtonText: 'Ok',
          })
        })
        .finally(() => {
          refetchData()
        })
    }
    const downloadMessPdfsNfe = async arrayIdPedidos => {
      try {
        showLoadingGenrandoNfe.value = true;
        let currentDownload = 0;

        // eslint-disable-next-line no-restricted-syntax
        for (const pedido of arrayIdPedidos) {
          // eslint-disable-next-line no-plusplus
          currentDownload++;
          nameLoading.value = `Fazendo download de ${currentDownload}/${arrayIdPedidos.length}`
          // eslint-disable-next-line no-await-in-loop
          await downloadPdfLink(pedido)
        }

        showLoadingGenrandoNfe.value = false;
      } catch (error) {
        console.error('Erro ao fazer o download:', error)
        showLoadingGenrandoNfe.value = false;
      }
    }
    const gerarNfeInMass = async arrayIdPedidos => {
      showLoadingGenrandoNfe.value = true
      await sendMassNfeBling(arrayIdPedidos.map(p => p.id))
        .then(response => {
          SweetAlert.fire({
            icon: 'success',
            title: 'Sucesso',
            text: response.message,
            confirmButtonText: 'Ok',
          })
        })
        .catch(() => {
          SweetAlert.fire({
            icon: 'error',
            title: 'Tente novamente mais tarde',
            text: 'Não foi possível gerar as notas fiscais eletrônica',
            confirmButtonText: 'Ok',
          })
        })
        .finally(() => {
          showLoadingGenrandoNfe.value = false
          refetchData()
        })
    }
    const gerarNfe = async arrayIdPedidos => {
      showLoadingGenrandoNfe.value = true
      await sendNfeBling(arrayIdPedidos.map(p => p.id))
        .then(response => {
          SweetAlert.fire({
            icon: 'success',
            title: 'Sucesso',
            text: response.message,
            confirmButtonText: 'Ok',
          })
        })
        .catch(() => {
          SweetAlert.fire({
            icon: 'error',
            title: 'Tente novamente mais tarde',
            text: 'Não foi possível gerar a nota fiscal eletrônica',
            confirmButtonText: 'Ok',
          })
        })
        .finally(() => {
          showLoadingGenrandoNfe.value = false
          refetchData()
        })
    }

    return {
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refPedidosListTable,

      statusFilter,
      metodoPaymentFilter,
      metodoPaymentOptions,
      integracaoFilter,
      integracaoOptions,
      dataInicioFilter,
      dataFimFilter,

      refetchData,

      statusOptions,

      avatarText,
      resolverOrderStatusIconAndVariant,
      resolverStatusVariante,
      resolveStatusText,
      resolveCondicaoPagamento,
      resolveCondicaoPagamentoVariant,
      resolveAprovado,
      resolveAprovadoVariant,
      // processarPedido,
      showLoadingGenrandoNfe,
      nameLoading,
      gerarNfe,
      gerarNfeInMass,
      downloadMessPdfsNfe,
      downloadPdfLink,
      reenviarEmailPix,
      onRowSelected,
      selected,

      calcularTotalComissoes,
    }
  },
  mounted() {
    // Aplicar filtros baseados nos query parameters
    if (this.$route.query.status) {
      this.statusFilter = this.$route.query.status
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
